/**
 *
 * ParrotSoftware
 * OnlineOrderingProvider root
 *
 */
import { Children, memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function OnlineOrderingProvider({ children }) {
  useInjectSaga({ key: 'onlineOrderingProvider', saga });
  useInjectReducer({ key: 'onlineOrderingProvider', reducer });

  return Children.only(children);
}

OnlineOrderingProvider.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withOnlineOrdering } from './withOnlineOrdering';
export default compose(withConnect, memo)(OnlineOrderingProvider);
